'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { useDisclosure } from '@/app/hooks/useDisclosure';
import { GalleryCarousel } from '@/app/lcv/components/sections/compare/list/header-cta/gallery/carousel';
import { PRODUCT_COMPARE_DATA_TEST } from '@/app/lcv/components/sections/compare/tracking';
import type { LcvCompareModel } from '@/app/lcv/components/sections/compare/types';
import { getLcvCategoryFromLcvModel } from '@/app/lcv/components/sections/compare/utils';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { safeCall } from '@/app/utils/safeCall';
import type { LcvModelColor } from '@/types/tis-cms/types';
const ModalGalleryZoom = dynamic(() => import('@/app/lcv/components/sections/compare/list/header-cta/gallery/modal-gallery-zoom').then(mod => mod.ModalGalleryZoom), {
  ssr: false
});
interface CompareListGalleryProps {
  model?: LcvCompareModel;
  selectedColor?: LcvModelColor;
  columnIndex: number;
  onSlideChange: (index: number) => void;
}
export const CompareListGallery = t0 => {
  const $ = _c(25);
  const {
    model,
    selectedColor,
    columnIndex,
    onSlideChange
  } = t0;
  const [activeIndex, setActiveIndex] = useState(0);
  const [isOpen, t1] = useDisclosure(false);
  const {
    close,
    open
  } = t1;
  let t2;
  if ($[0] !== model) {
    t2 = model ? getLcvCategoryFromLcvModel(model) : undefined;
    $[0] = model;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const category = t2;
  const isImagesReady = !!category && !!model && !!selectedColor?.front?.url;
  let t3;
  if ($[2] !== onSlideChange) {
    t3 = index => {
      setActiveIndex(index);
      safeCall(onSlideChange, index);
    };
    $[2] = onSlideChange;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleOnSlideChange = t3;
  const t4 = `${PRODUCT_COMPARE_DATA_TEST.image}-${columnIndex}`;
  let t5;
  if ($[4] !== t4) {
    t5 = createDataAttributes({
      test: t4
    });
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = category ?? undefined;
  let t7;
  if ($[6] !== handleOnSlideChange || $[7] !== isImagesReady || $[8] !== model || $[9] !== open || $[10] !== selectedColor || $[11] !== t6) {
    t7 = <GalleryCarousel model={model} category={t6} selectedColor={selectedColor} isImagesReady={isImagesReady} onSlideChange={handleOnSlideChange} onClickSlide={open} />;
    $[6] = handleOnSlideChange;
    $[7] = isImagesReady;
    $[8] = model;
    $[9] = open;
    $[10] = selectedColor;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== activeIndex || $[14] !== category || $[15] !== close || $[16] !== isImagesReady || $[17] !== isOpen || $[18] !== model || $[19] !== selectedColor) {
    t8 = !!isOpen && !!isImagesReady && !!category && <ModalGalleryZoom model={model} category={category} selectedColor={selectedColor} startIndex={activeIndex} onClose={close} />;
    $[13] = activeIndex;
    $[14] = category;
    $[15] = close;
    $[16] = isImagesReady;
    $[17] = isOpen;
    $[18] = model;
    $[19] = selectedColor;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t5 || $[22] !== t7 || $[23] !== t8) {
    t9 = <div {...t5}>{t7}{t8}</div>;
    $[21] = t5;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};